<template>
  <div class="page">
      <div class="container">
          <div class="recommend-part">
              <!-- 所向由心 欢迎来到起亚社区 -->
              <img class="welcome-img" :src="preText + '/assets/~/media/images/community/welcome.png'" alt="" />
              <!-- 发动态 写文章 按钮 -->
              <div
                class="button-part"
                :class="{ 'button-part--absolute': isPortrait && isButtonAbsolute }"
              >
                  <img 
                      @click="handleMomentButtonClick()" code-stm="event, PAGEURL, 点击发动态按钮"
                      ref="momentButton"
                      class="button-moment" 
                      :src="preText + (!isPortrait ? '/assets/~/media/images/community/button-moment-dark.png' : '/assets/~/media/images/community/mob/button-moment-dark.png')" 
                      alt="" />
                  <img 
                      @click="handleArticleButtonClick()" code-stm="event, PAGEURL, 点击写文章按钮"
                      ref="articleButton" 
                      class="button-article" 
                      :src="preText + (!isPortrait ? '/assets/~/media/images/community/button-article-light.png' : '/assets/~/media/images/community/mob/button-article-light.png')" 
                      alt="" />
              </div>
              <!-- 发表动态 输入框 图片上传 -->
              <div v-if="!isPortrait" class="moment-part">
                  <el-input class="moment-input" v-model="authForm.content" type="textarea" maxlength="200" show-word-limit placeholder="一起聊会儿呀～" />
                  <div class="moment-upload">
                      <div :class="['image-upload-wrapper', { 'image-upload-hidden': !showImageUpload }]">
                        <ImageUpload
                            v-model="authForm.imgList"
                            ref="imageUploadRef"
                            :uploadImgUrl="uploadImgUrl"
                            :limit="9"
                            :fileSize="5"
                            :imgKind="'cover'"
                            :headers="headers"
                            upload-img-type="community"
                            @input="handleUpdateModelValue">
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                        </ImageUpload>
                      </div>
                      <div class="moment-upload-row">
                          <div
                            class="upload-image-btn"
                            :class="{ 'is-loading': uploadImageCheckingLogin }"
                            @click="handleUploadImage"
                          >
                            <img 
                                ref="imageButton"
                                class="moment-upload-image" 
                                :src="preText + '/assets/~/media/images/community/button-image.png'" 
                                
                                alt="" code-stm="event, PAGEURL, 点击上传图片按钮">
                            <div v-if="uploadImageCheckingLogin" class="upload-image-mask">
                              <span class="upload-image-spinner"></span>
                            </div>
                          </div>
                          <div class="moment-upload-tip">备注：上传图片支持格式：.jpg、.png，单个文件不能超过2MB，最多上传9张图片。</div>
                      </div>
                  </div>
              </div>
              <div v-if="!isPortrait" class="submit-button-part">
                  <img @click="handleSubmit" 
                  code-stm="event, PAGEURL, 发表动态提交"
                  :src="preText + (submitEnable ? '/assets/~/media/images/community/button-submit.png': '/assets/~/media/images/community/button-submit-disable.png')" alt="">
              </div>

              <!-- 推荐 -->
              <div class="list-title">
                  <img :src="preText + '/assets/~/media/images/community/icon-recommend.png'" alt="">
              </div>

              <!-- 推荐列表 list-part -->
              <div class="recommend-list-part">
                  <div class="recommend-card" v-for="item in recommendList" :key="item.id" :data-id="item.id">
                      <div class="card-info">
                          <img class="info-avatar" :src="item.userProfileImg" alt="">
                          <div class="info-text">
                              <div class="info-name">{{ item.nickName }}</div>
                              <div class="info-time">{{ formatDate(item.createTime) }}</div>
                          </div>
                      </div>
                      <div class="card-content" @click="handleDetail(item.id)" code-stm="event, PAGEURL, 点击文章/动态评论进入详情">{{ getCardContent(item) }}</div>
                      <img class="card-image" :src="getCardImage(item)" alt="" @click="handleDetail(item.id)" code-stm="event, PAGEURL, 点击文章/动态评论进入详情">
                      <div class="card-footer">
                          <div class="card-footer-item" @click="handleDetail(item.id)">
                              <img code-stm="event, PAGEURL, 点击文章/动态评论进入详情"
                              :src="preText + '/assets/~/media/images/community/icon-comments.png'" alt="">
                              <div code-stm="event, PAGEURL, 点击文章/动态评论进入详情">{{ item.discussCount || '评论' }}</div>
                          </div> 
                          <div
                            class="card-footer-item"
                            :class="{ 'is-loading': !!likeLoginLoadingMap[item.id] }"
                            @click="handleLike(item.id)"
                          >
                              <img :code-stm="'event, PAGEURL, 文章/动态' + (item.isLiked ? '取消点赞' : '点赞')"
                              :src="preText + (item.isLiked ? '/assets/~/media/images/community/icon-like-red.png' : '/assets/~/media/images/community/icon-like.png')" alt="">
                              <div :code-stm="'event, PAGEURL, 文章/动态' + (item.isLiked ? '取消点赞' : '点赞')">{{ item.likesCount || '点赞' }}</div>
                              <div v-if="likeLoginLoadingMap[item.id]" class="footer-loading-mask">
                                <span class="footer-spinner"></span>
                              </div>
                          </div>
                      </div>
                  </div> 
                  <!-- 滑动至视口底部自动加载更多 -->
                  <div class="load-part">
                      <div
                        v-show="showLoadMore"
                        ref="loadMoreSentinel"
                        class="load-more-sentinel"
                        aria-hidden="true"
                      />
                      <div v-show="isLoading" class="load-ing">
                          <div class="circle"></div>
                          <img :src="preText + '/assets/~/media/images/community/load-ing.png'" alt="">
                      </div>
                      <img
                        v-show="isAllLoaded && total > 0"
                        class="load-end"
                        :src="preText + '/assets/~/media/images/community/load-end.png'"
                        alt="">
                  </div>
              </div>
          </div>

          <!-- 广告位 仅pc-->
          <div v-show="!isPortrait" class="advertise-part">
              <Advertise />
          </div>
      </div>

      <!-- mob发表动态弹窗 -->
      <div v-if="isPortrait && momentPopupVisible" class="moment-popup">
        <img class="back-button" @click="handleCloseMomentPopup" 
        code-stm="event, PAGEURL, 关闭发表动态弹窗"
        :src="preText + '/assets/~/media/images/community/mob/button-back-moment.png'" alt="">
        <div class="moment-part">
            <el-input class="moment-input" v-model="authForm.content" type="textarea" maxlength="200" show-word-limit placeholder="一起聊会儿呀～" />
            <div class="moment-upload">
                <div :class="['image-upload-wrapper', { 'image-upload-hidden': !showImageUpload }]">
                  <ImageUpload
                      :isPortrait="isPortrait"
                      v-model="authForm.imgList"
                      ref="imageUploadRef"
                      :uploadImgUrl="uploadImgUrl"
                      :limit="9"
                      :fileSize="5"
                      :imgKind="'cover'"
                      :headers="headers"
                      upload-img-type="community"
                      @input="handleUpdateModelValue">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                  </ImageUpload>
                </div>
                <div class="moment-upload-row">
                    <img 
                        ref="imageButton"
                        @click="handleUploadImage" 
                        class="moment-upload-image" 
                        :src="preText + '/assets/~/media/images/community/button-image.png'" 
                        
                        alt="" code-stm="event, PAGEURL, 点击上传图片按钮">
                    <div class="moment-upload-tip">备注：上传图片支持格式：.jpg、.png，单个文件不能超过2MB，最多上传9张图片。</div>
                </div>
            </div>
        </div>
        <div class="submit-button-part"></div>
        <img class="submit-button" @click="handleSubmit" 
        code-stm="event, PAGEURL, 发表动态提交"
        :src="preText + (submitEnable ? '/assets/~/media/images/community/mob/button-comment.png': '/assets/~/media/images/community/mob/button-comment-disable.png')" alt="">
      </div>

      <!-- 提交结果弹窗 -->
      <Popup
        :visible="popupVisible"
        :title="popupInfo.title"
        :content="popupInfo.content"
        :button-text="popupInfo.button || popupInfo.type || '确定'"
        @close="closePopup"
        @confirm="handlePopupConfirm"
      />

      <!-- 发布动态：全屏 loading（pc + mob） -->
      <div v-if="isSubmitting" class="fullscreen-loading">
        <div class="fullscreen-loading__spinner"></div>
        <div class="fullscreen-loading__text">提交中…</div>
      </div>

      <!-- 入口 checkLogin：全屏 loading（pc + mob） -->
      <div v-if="isCheckingLogin" class="fullscreen-loading">
        <div class="fullscreen-loading__spinner"></div>
        <div class="fullscreen-loading__text">加载中…</div>
      </div>
  </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload/index';
import { queUrl } from '@/config/base';
import Advertise from '@/components/community/advertise';
import Popup from '@/components/community/popup';
import { isPortraitFun, utf8_to_b64 } from "@/utils/utils.js";
import $ from 'jquery'
export default {
name: 'Recommend',
components: {
  ImageUpload,
  Advertise,
  Popup
},
activated() {
  // 从登录页返回/页面重新激活时刷新 Token、环境域名
  this.refreshRuntime();
},
data() {
  return {
      isPortrait: isPortraitFun(),
      isButtonAbsolute: false, // 移动端：当 Footer 进入视口时改为 absolute，避免压住 Footer
      authForm: {
          imgList: '',
          content: ''
      },
      popSuccessInfo: {
        title: '提交成功',
        content: '您编辑的内容已成功提交审核，感谢您的分享！',
        button: '我知道了',
      },
      popErrorInfo: {
        title: '内容审核不通过',
        content: '您提交内容中含有禁止内容，请修改后重新提交',
        type: '返回修改',
      },
      popupVisible: false,
      popupInfo: {},
      showImageUpload: false,
      headers: {},
      preText:'https://www.kia.cn',
      recommendList: [],
      uploadImgUrl:  `${queUrl}interface/ossClient/upload`,
      pageNum: 1,
      pageSize: 5,
      total: 0,
      isLoading: false,
      noMore: false, // 后端不可靠返回 total 时，用于标记“没有更多”
      momentPopupVisible: false,
      // 提交防抖：用于防止多次快速点击提交按钮
      isSubmitting: false,
      // 点赞前 checkLogin 的加载态（按文章 id）
      likeLoginLoadingMap: {},
      // 入口按钮（写文章/发动态）checkLogin 的全屏 loading
      isCheckingLogin: false,
      // PC 上传图片按钮：checkLogin 过程 loading
      uploadImageCheckingLogin: false,
      // 返回详情前的滚动锚点（用于刷新后回到原位置）
      restoreAnchorId: '',
      restoreAnchorOffsetTop: 0,
      loadMoreObserver: null,
      /** 触底后需再向上滑大约多少像素（哨兵相对视口底边上移）才加载更多；调大则更晚加载 */
      loadMoreExtraScrollPx: 120,
  }
},
computed: {
  submitEnable() {
    const hasContent = this.authForm.content && this.authForm.content.trim().length > 0;
    const hasImages = this.hasAnyImage(this.authForm.imgList);
    return hasContent && hasImages;
  },
  isAllLoaded() {
    const reachedTotal = this.total > 0 && this.recommendList.length >= this.total;
    return reachedTotal || this.noMore;
  },
  showLoadMore() {
    return !this.isLoading && !this.isAllLoaded;
  }
},
beforeRouteLeave(to, from, next) {
  // 离开页面时保存列表状态
  try {
    // 记录当前滚动锚点：取视口内最靠上的卡片 id + 它到视口顶部的距离
    const anchor = this.getScrollAnchor();
    const anchorState = {
      scrollY: typeof window !== 'undefined' ? (window.pageYOffset || 0) : 0,
      anchorId: anchor && anchor.id ? String(anchor.id) : '',
      anchorOffsetTop: anchor && typeof anchor.offsetTop === 'number' ? anchor.offsetTop : 0,
    };
    sessionStorage.setItem('recommend_scroll_anchor', JSON.stringify(anchorState));

    const listState = {
      pageNum: this.pageNum,
      recommendList: this.recommendList,
      total: this.total,
      noMore: this.noMore
    };
    sessionStorage.setItem('recommend_list_state', JSON.stringify(listState));
  } catch (e) {
    // ignore save error
  }
  next();
},
mounted() {
  // 初始化 headers
  this.refreshRuntime();
  // 覆盖从登录页 history.back() 返回（bfcache 恢复）场景：mounted 不会再触发
  window.addEventListener('pageshow', this.handlePageShow);
  // 登录后从本地恢复未提交的内容
  try {
    const draftContent = localStorage.getItem('community_recommend_content');
    if (draftContent) {
      this.authForm.content = draftContent;
      localStorage.removeItem('community_recommend_content');
    }
  } catch (e) {
    // ignore restore error
  }
  // If page has pre-filled images, show uploader immediately
  this.showImageUpload = this.hasAnyImage(this.authForm.imgList);

  // 移动端：先绑定滚动监听（必须在“从 detail 返回直接 return”之前绑定）
  if (this.isPortrait) {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    // 锁定背景滚动，只允许弹窗内容滚动
    document.addEventListener('touchmove', this.handleGlobalTouchMove, { passive: false });
    this.$nextTick(() => {
      this.handleScroll();
    });
  }
  
  // 尝试恢复之前保存的列表状态（仅当从其他页面返回时）
  try {
    const savedState = sessionStorage.getItem('recommend_list_state');
    const fromDetail = sessionStorage.getItem('from_detail_page'); // 标记是否从 detail 返回
    const savedAnchorRaw = sessionStorage.getItem('recommend_scroll_anchor');
    
    if (savedState && fromDetail === 'true') {
      const listState = JSON.parse(savedState);
      // 恢复列表状态
      if (listState.recommendList && Array.isArray(listState.recommendList) && listState.recommendList.length > 0) {
        this.pageNum = listState.pageNum || 1;
        this.recommendList = listState.recommendList;
        this.total = listState.total || 0;
        this.noMore = listState.noMore || false;
        // 恢复滚动锚点
        try {
          const savedAnchor = savedAnchorRaw ? JSON.parse(savedAnchorRaw) : null;
          this.restoreAnchorId = savedAnchor && savedAnchor.anchorId ? String(savedAnchor.anchorId) : '';
          this.restoreAnchorOffsetTop = savedAnchor && typeof savedAnchor.anchorOffsetTop === 'number'
            ? savedAnchor.anchorOffsetTop
            : 0;
          const scrollY = savedAnchor && typeof savedAnchor.scrollY === 'number' ? savedAnchor.scrollY : 0;
          this.$nextTick(() => {
            if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
              window.scrollTo(0, scrollY);
            }
          });
        } catch (e) {
          // ignore parse/restore error
        }
        // 清除保存的状态和标记
        sessionStorage.removeItem('recommend_list_state');
        sessionStorage.removeItem('recommend_scroll_anchor');
        sessionStorage.removeItem('from_detail_page');
        // 恢复状态后主动刷新一次按钮定位状态
        this.$nextTick(() => {
          this.handleScroll();
        });
        // 体验：先“秒回位”，再后台刷新已加载范围的数据，并保持回到原位置
        this.$nextTick(() => {
          this.refreshRecommendListKeepPosition();
        });
        this.$nextTick(() => {
          this.setupLoadMoreObserver();
        });
        return;
      }
    }
    // 清除可能存在的旧标记
    sessionStorage.removeItem('from_detail_page');
    sessionStorage.removeItem('recommend_scroll_anchor');
  } catch (e) {
    // ignore restore error
  }
  
  // 如果没有保存的状态，才重置加载
  this.getRecommendList(true);
  this.$nextTick(() => {
    this.setupLoadMoreObserver();
  });
},
beforeDestroy() {
  this.teardownLoadMoreObserver();
  if (this.isPortrait) {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('touchmove', this.handleGlobalTouchMove);
  }
  window.removeEventListener('pageshow', this.handlePageShow);
},
methods: {
  getScrollAnchor() {
    try {
      const cards = this.$el ? this.$el.querySelectorAll('.recommend-card') : null;
      if (!cards || !cards.length) return null;
      const viewportTop = 0;
      let best = null;
      let bestTop = Number.POSITIVE_INFINITY;
      cards.forEach((el) => {
        if (!el || typeof el.getBoundingClientRect !== 'function') return;
        const rect = el.getBoundingClientRect();
        // 选“在视口内或刚上方一点”的卡片作为锚点，优先最靠近顶部的
        if (rect.bottom <= viewportTop) return;
        const top = Math.max(rect.top, viewportTop);
        if (top < bestTop) {
          bestTop = top;
          best = el;
        }
      });
      if (!best) return null;
      const id = best.getAttribute('data-id') || '';
      const rect = best.getBoundingClientRect();
      return {
        id,
        offsetTop: rect.top,
      };
    } catch (e) {
      return null;
    }
  },
  scrollToAnchor() {
    if (!this.restoreAnchorId) return;
    try {
      const selector = `.recommend-card[data-id="${this.restoreAnchorId}"]`;
      const el = this.$el ? this.$el.querySelector(selector) : null;
      if (!el || typeof el.getBoundingClientRect !== 'function') return;
      const rect = el.getBoundingClientRect();
      const currentTop = rect.top;
      const delta = currentTop - (this.restoreAnchorOffsetTop || 0);
      if (typeof window !== 'undefined' && typeof window.scrollBy === 'function') {
        window.scrollBy(0, delta);
      }
    } catch (e) {
      // ignore
    }
  },
  refreshRecommendListKeepPosition() {
    // 后台刷新：按“当前已加载数量”拉一次，替换列表；然后滚动回锚点
    if (this.isLoading) return;
    const loadedSize = Math.max(
      Array.isArray(this.recommendList) ? this.recommendList.length : 0,
      (Number(this.pageNum || 1) - 1) * Number(this.pageSize || 5)
    );
    if (!loadedSize) return;

    this.isLoading = true;
    this.$axios
      .get(`${queUrl}api/community/client/list`, {
        params: {
          pageNum: 1,
          pageSize: loadedSize
        },
        headers: this.headers
      })
      .then((res) => {
        if (res.data.code == 200) {
          const rows = Array.isArray(res.data.rows) ? res.data.rows : [];
          this.total = res.data.total || this.total || 0;
          // 直接替换为最新 rows（长度 <= loadedSize）
          this.recommendList = rows;
          // 由于替换后 DOM 重新渲染，下一帧把滚动对齐回锚点
          this.$nextTick(() => {
            this.scrollToAnchor();
            this.handleScroll();
          });
        }
      })
      .catch(() => {})
      .finally(() => {
        this.isLoading = false;
      });
  },
  handlePageShow() {
    // pageshow 会在 bfcache 恢复时触发：刷新 Token、环境域名
    this.refreshRuntime();
  },
  refreshRuntime() {
    this.refreshHeaders();
    if (typeof window !== 'undefined') {
      this.preText = window.location.href.includes('https://www.kia.cn')
        ? 'https://www.kia.cn'
        : 'https://uat.kia.cn';
    }
  },
  refreshHeaders() {
    // 统一从本地 user 刷新 token，避免登录后返回仍用旧 headers
    this.headers = { Token: this.getToken() };
  },
  handleCloseMomentPopup() {
    this.momentPopupVisible = false;
  },
  handleSubmit() {
      // 防抖：提交中直接忽略后续点击
      if (this.isSubmitting) return;
      var that = this;
      var submitData = {
        content: utf8_to_b64(that.authForm.content),
        imgList: that.authForm.imgList.img,
      }
    if (this.submitEnable) {
      // 标记为提交中
      this.isSubmitting = true;
      this.$axios
      .post(`${queUrl}interface/community/client/saveDynamic`, submitData, {
        headers: this.headers
      })
      .then((res) => {
        if(res.data.code == 200) {
          this.openPopup(this.popSuccessInfo);
          // 发布成功后，清空表单
          that.authForm.content = '';
          that.authForm.imgList = '';
          that.showImageUpload = false;
          // mob：发布成功后关闭“发表动态”弹窗
          if (this.isPortrait) {
            this.momentPopupVisible = false;
          }
        } else {
          if(res.data.msg == '文本检测违规' || res.data.msg == '图片检测违规'){
            this.openPopup(this.popErrorInfo);
          }else{
            this.$message.error(res.data.message);
          }
        }
        // 请求完成，允许再次提交
        this.isSubmitting = false;
      })
      .catch(() => {
        // 异常时也需要恢复提交状态
        this.isSubmitting = false;
      });
    }
  },
  openPopup(info) {
    this.popupInfo = info || {};
    this.popupVisible = true;
  },
  closePopup() {
    this.popupVisible = false;
  },
  handlePopupConfirm() {
    this.closePopup();
  },
  hasAnyImage(val) {
    if (!val) return false;
    if (Array.isArray(val)) return val.length > 0;
    if (typeof val === 'object') return !!(val.img || val.url || val.length);
    if (typeof val === 'string') return val.trim().length > 0;
    return false;
  },
  checkLogin() {
    // 判断是否登录（本地有 user 且 token 不为空）
    const getUserInfo = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : null;
    const isLogin = !!(getUserInfo && getUserInfo.token);

    if (!isLogin) { // 未登录
      console.log('未登录');
      // 跳转前先保存当前未提交内容，登录回来后恢复
      if (this.authForm && typeof this.authForm.content === 'string') {
        localStorage.setItem('community_recommend_content', this.authForm.content);
      }
      //跳转登录页面
      window.parent.location.href = this.preText + '/user-management/login?recommend=recommend';
      // window.parent.location.href = 'http://192.168.1.148:5173/user-management/login?community/recommend';//本地测试
      return Promise.resolve(false); // 未登录：直接返回 false
    }

    // 已登录，进一步判断 token 是否过期（异步接口）
    let aURL = '';
    if (window.location.href.includes('www.kia.cn')) {
      aURL = 'https://kiacarservice.kia.cn/kia-carservice-api';
    } else if (window.location.href.includes('uat.kia.cn')) {
      aURL = 'https://kiacarservice-uat.kia.cn/kia-carservice-api';
    } else {
      aURL = 'http://kiatest.runlin.cn/kia-carservice-api';
    }

    const token = getUserInfo.token;
    const userId = getUserInfo.userId;

    var that = this;
    // 返回 Promise<boolean>：true 表示 token 有效，false 表示已过期
    return new Promise((resolve) => {
      $.ajax({
        url: aURL + '/user/info',
        type: 'get',
        dataType: 'json',
        data: { userId },
        beforeSend: (xhr) => {
          xhr.setRequestHeader('Token', token);
        },
        success: (res) => {
          if (res.code === 0 && res.data) {
            // token 未过期
            console.log('token 未过期');
            resolve(true);
          } else {
            // 过期：清除本地 user
            console.log('token 过期');
            // 跳转前先保存当前未提交内容，登录回来后恢复
            if (that.authForm && typeof that.authForm.content === 'string') {
              localStorage.setItem('community_recommend_content', that.authForm.content);
            }
            localStorage.removeItem('user');
            window.parent.location.href = that.preText + '/user-management/login?community=recommend';
            resolve(false);
          }
        },
        error: (err) => {
          // 接口异常也视为过期
          if (err && err.status === 401) {
            console.log('异常');
            // 跳转前先保存当前未提交内容，登录回来后恢复
            if (that.authForm && typeof that.authForm.content === 'string') {
              localStorage.setItem('community_recommend_content', that.authForm.content);
            }
            localStorage.removeItem('user');
            window.parent.location.href = that.preText + '/user-management/login?community=recommend';
          }
          resolve(false);
        },
      });
    });
  },
  async handleArticleButtonClick() {
    if (this.isCheckingLogin) return;
    this.isCheckingLogin = true;
    try {
      const ok = await this.checkLogin();
      if (!ok) return;
      this.$router.push(`/article`);
    } finally {
      this.isCheckingLogin = false;
    }
  },
  async handleMomentButtonClick() {//只有mob有此功能
    if (!this.isPortrait) {
      return;
    }else{
      //打开弹窗
      if (this.isCheckingLogin) return;
      this.isCheckingLogin = true;
      try {
        const ok = await this.checkLogin();
        if (!ok) return;
        this.momentPopupVisible = true;
      } finally {
        this.isCheckingLogin = false;
      }
    }
  },
  getToken() {
      var getUserInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
      if (!getUserInfo) {
          return '';
      }
      return getUserInfo.token || '';
  },
  getRecommendList(isReset = false) {
    if (this.isLoading) return;
    if (!isReset && this.isAllLoaded) return;

    if (isReset) {
      this.pageNum = 1;
      this.total = 0;
      this.noMore = false;
      this.recommendList = [];
    }

    this.isLoading = true;
    this.$axios
      .get(`${queUrl}api/community/client/list`, {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        },
        headers: this.headers
      })
      .then((res) => {
        if (res.data.code == 200) {
          this.total = res.data.total || 0;
          const rows = Array.isArray(res.data.rows) ? res.data.rows : [];

          // 追加数据时去重（按 id），避免后端总返回前几条导致重复叠加
          const existingIds = new Set(this.recommendList.map(item => item.id));
          const newRows = isReset
            ? rows
            : rows.filter(item => !existingIds.has(item.id));

          this.recommendList = isReset ? rows : this.recommendList.concat(newRows);

          // 如果返回条数小于 pageSize，说明已经是最后一页
          if (rows.length < this.pageSize || rows.length === 0) {
            this.noMore = true;
          }

          // 只有在接口真的返回数据时才翻到下一页
          if (rows.length > 0) this.pageNum += 1;
        } else {
          this.$message.error(res.data.message);
        }
      })
      .catch(() => {})
      .finally(() => {
        this.isLoading = false;
      });
  },
  // 滑动触底加载更多（由 IntersectionObserver 触发）
  handleLoadMore() {
    this.getRecommendList(false);
  },
  setupLoadMoreObserver() {
    this.teardownLoadMoreObserver();
    if (typeof IntersectionObserver === 'undefined') {
      this._scrollLoadMoreHandler = () => {
        if (this.isLoading || this.isAllLoaded || !this.showLoadMore) return;
        const el = this.$refs.loadMoreSentinel;
        if (!el || typeof el.getBoundingClientRect !== 'function') return;
        const top = el.getBoundingClientRect().top;
        const line = window.innerHeight - this.loadMoreExtraScrollPx;
        if (top < line) {
          this.handleLoadMore();
        }
      };
      window.addEventListener('scroll', this._scrollLoadMoreHandler, { passive: true });
      return;
    }
    this.$nextTick(() => {
      const el = this.$refs.loadMoreSentinel;
      if (!el) return;
      const past = Math.max(0, Number(this.loadMoreExtraScrollPx) || 0);
      this.loadMoreObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry || !entry.isIntersecting) return;
          if (this.isLoading || this.isAllLoaded) return;
          this.handleLoadMore();
        },
        {
          root: null,
          // 底部用负 margin：相交区域比视口「少一截」底边，等于到底后再多滑 past 像素才触发
          rootMargin: `0px 0px -${past}px 0px`,
          threshold: 0,
        }
      );
      this.loadMoreObserver.observe(el);
    });
  },
  teardownLoadMoreObserver() {
    if (this.loadMoreObserver) {
      this.loadMoreObserver.disconnect();
      this.loadMoreObserver = null;
    }
    if (this._scrollLoadMoreHandler) {
      window.removeEventListener('scroll', this._scrollLoadMoreHandler);
      this._scrollLoadMoreHandler = null;
    }
  },
  //格式化日期
  formatDate(dateTimeStr) {
    // input: YYYY-MM-DD HH:mm:ss -> output: YYYY-MM-DD
    // if (!dateTimeStr) return '';
    // if (typeof dateTimeStr !== 'string') return '';
    // return dateTimeStr.split(' ')[0];
    return dateTimeStr;
  },
  //获取卡片内容
  getCardContent(item) {
    if (!item) return '';
    // type==1: 文章 -> title; type==2: 动态 -> content
    if (item.type == 1) return item.title || '';
    if (item.type == 2) return item.content || '';
    // fallback
    return item.content || item.title || '';
  },
  //获取卡片图片
  getCardImage(item) {
    if (!item) return '';
    // type==1: 文章 -> mainImg
    if (item.type == 1) return item.mainImg || '';
    // type==2: 动态 -> imgList first (comma-separated string)
    if (item.type == 2) {
      const listStr = item.imgList;
      if (!listStr || typeof listStr !== 'string') return '';
      const first = listStr.split(',').map(s => s.trim()).find(Boolean);
      return first || '';
    }
    // fallback to existing fields
    return item.mainImg || item.img || '';
  },
  //上传图片
  async handleUploadImage() {
    if(!this.isPortrait){
      if (this.uploadImageCheckingLogin) return;
      this.uploadImageCheckingLogin = true;
      const ok = await this.checkLogin();
      this.uploadImageCheckingLogin = false;
      if (!ok) return;
    }
    // open file dialog (uploader is mounted but may be visually hidden)
    this.$nextTick(() => {
      const uploader = this.$refs.imageUploadRef;
      if (uploader && typeof uploader.openFileDialog === 'function') {
        uploader.openFileDialog();
        return;
      }
      // fallback: try to click underlying input directly
      const el = uploader && uploader.$el;
      const input = el && el.querySelector && el.querySelector('input[type="file"]');
      if (input && typeof input.click === 'function') input.click();
    });
  },
  handleUpdateModelValue(value) {
    this.authForm.imgList = value;
    // Show uploader when there are images; hide it again when images are deleted to 0
    this.showImageUpload = this.hasAnyImage(value);
  },
  // handleMomentHover(isHovered) {
  //   if (this.$refs.momentButton) {
  //     this.$refs.momentButton.src = this.preText + (isHovered 
  //       ? '/assets/~/media/images/community/button-moment-light.png' 
  //       : '/assets/~/media/images/community/button-moment-dark.png');
  //   }
  // },
  // handleArticleHover(isHovered) {
  //   if (this.$refs.articleButton) {
  //     this.$refs.articleButton.src = this.preText + (isHovered 
  //       ? '/assets/~/media/images/community/button-article-dark.png' 
  //       : '/assets/~/media/images/community/button-article-light.png');
  //   }
  // },
  handleImageHover(isHovered) {
    if (this.$refs.imageButton) {
      this.$refs.imageButton.src = this.preText + (isHovered 
        ? '/assets/~/media/images/community/button-image-hover.png' 
        : '/assets/~/media/images/community/button-image.png');
    }
  },
  // 本地点赞记录（localStorage）
  getLocalLikedIds() {
    try {
      const raw = localStorage.getItem('community_liked_article_ids');
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  },
  setLocalLikedIds(ids) {
    localStorage.setItem('community_liked_article_ids', JSON.stringify(ids || []));
  },
  isLocallyLiked(id) {
    if (id === undefined || id === null) return false;
    return this.getLocalLikedIds().includes(id);
  },
  addLocalLike(id) {
    const ids = this.getLocalLikedIds();
    if (!ids.includes(id)) {
      ids.push(id);
      this.setLocalLikedIds(ids);
    }
  },
  removeLocalLike(id) {
    const ids = this.getLocalLikedIds().filter(x => x !== id);
    this.setLocalLikedIds(ids);
  },
  //点赞
  async handleLike(id) {
    if (id === undefined || id === null) return;
    if (this.likeLoginLoadingMap[id]) return;
    this.$set(this.likeLoginLoadingMap, id, true);
    const ok = await this.checkLogin();
    this.$delete(this.likeLoginLoadingMap, id);
    if (!ok) return;
    const item = this.recommendList.find(it => it && it.id === id);
    if (!item) return;

    const alreadyLiked = item.isLiked || this.isLocallyLiked(id);
    const prevLiked = !!item.isLiked;
    const prevCount = Number(item.likesCount) || 0;

    if (alreadyLiked) {
      // 取消点赞：本地 -1，并移除本地记录
      item.isLiked = false;
      item.likesCount = Math.max(prevCount - 1, 0);
      this.removeLocalLike(id);

      this.$axios
        .post(
          `${queUrl}interface/community/client/likeArticle?articleId=${id}`,
          {},
          { headers: this.headers }
        )
        .then((res) => {
          if (res.data.code == 200) {
            // 成功：保持取消后的状态
            return;
          }
          // 失败：回滚为已点赞
          item.isLiked = true;
          item.likesCount = prevCount;
          this.addLocalLike(id);
          this.$message.error(res.data.message);
        })
        .catch(() => {
          item.isLiked = true;
          item.likesCount = prevCount;
          this.addLocalLike(id);
        });
    } else {
      // 点赞：本地 +1，并记录本地已点赞
      item.isLiked = true;
      item.likesCount = prevCount + 1;
      this.addLocalLike(id);

      this.$axios
        .post(
          `${queUrl}interface/community/client/likeArticle?articleId=${id}`,
          {},
          { headers: this.headers }
        )
        .then((res) => {
          if (res.data.code == 200) {
            // 成功：保持已点赞状态
            return;
          }
          // 失败：回滚
          item.isLiked = prevLiked;
          item.likesCount = prevCount;
          this.removeLocalLike(id);
          this.$message.error(res.data.message);
        })
        .catch(() => {
          item.isLiked = prevLiked;
          item.likesCount = prevCount;
          this.removeLocalLike(id);
        });
    }
  },
  handleDetail(id) {
    // 设置标记，表示即将跳转到 detail 页面
    try {
      sessionStorage.setItem('from_detail_page', 'true');
    } catch (e) {
      // ignore
    }
    this.$router.push(`/detail?id=${id}`);
  },
  // 监听页面滚动：当全局 Footer 进入视口时，移动端按钮由 fixed 变为 absolute，避免压住 Footer
  handleScroll() {
    if (!this.isPortrait) return;
    try {
      // 直接通过 DOM 查询全局 Footer 容器（App.vue 中的 id="page1"）
      const footer = document.getElementById('page1');
      if (!footer || typeof footer.getBoundingClientRect !== 'function') {
        this.isButtonAbsolute = false;
        return;
      }
      const rect = footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      // 当 Footer 顶部进入视口时，按钮改为 absolute；否则保持 fixed 吸底
      this.isButtonAbsolute = rect.top <= viewportHeight;
    } catch (e) {
      this.isButtonAbsolute = false;
    }
  },
  // 全局 touchmove：弹窗打开时，阻止下层页面滚动，仅允许 .moment-popup 内部滚动
  handleGlobalTouchMove(e) {
    if (!this.isPortrait) return;
    if (!this.momentPopupVisible) return;

    const popup = this.$el && this.$el.querySelector('.moment-popup');
    try {
      if (popup && popup.contains(e.target)) {
        // 触点在弹窗内部：
        // 仅当弹窗内容实际可滚动时，才允许默认滚动；否则阻止，避免背景滚动
        const canScroll = popup.scrollHeight > popup.clientHeight;
        if (!canScroll && e.cancelable) {
          e.preventDefault();
        }
        return;
      }

      // 触点不在弹窗内时，阻止滚动，锁定背景
      if (e.cancelable) {
        e.preventDefault();
      }
    } catch (err) {
      // 兜底：出现异常也尽量阻止背景滚动
      if (e && e.cancelable) {
        e.preventDefault();
      }
    }
  }
}
}
</script>

<style scoped lang="scss">
.page {
position: relative;
background-color: rgba(247, 248, 250, 1);
@media (max-width: 768px) {/* 移动端 */
  width: 100%;
  /* 预留底部按钮条的高度，避免内容被遮挡 */
  padding-bottom: calc(188 / 750 * 100vw);
}
}

.container {

min-height: 100vh;
display: flex;
@media (min-width: 768px) {/* pc端 */
  padding: 78px 0;
  // padding-left:calc(123 / 1920 * 100vw);
  // padding-right:calc(123 / 1920 * 100vw);
  width: calc(1665 / 1920 * 100vw);
  max-width: 1400px;
  margin: 0 auto;
}
@media (max-width: 768px) {/* 移动端 */
  width: 100%;
  padding: 60px calc(42 / 750 * 100vw) calc(0 / 750 * 100vw) calc(42 / 750 * 100vw);
}
}

.fullscreen-loading {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
}
.fullscreen-loading__spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(255, 255, 255, 0.35);
  border-top-color: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  animation: fullscreenSpin 0.9s linear infinite;
}
.fullscreen-loading__text {
  margin-top: 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.92);
  font-family: "FZLanTingHeiS-R-GB";
}
@keyframes fullscreenSpin {
  to { transform: rotate(360deg); }
}

.recommend-part {
  @media (min-width: 768px) {/* pc端 */
  //   width: calc(1092 / 1920 * 100vw);
  
      width: 65.5%;
  }
  @media (max-width: 768px) {/* 移动端 */
    width: 100%;
  }
}

.welcome-img {
@media (min-width: 768px) {/* pc端 */
  width: auto;
  height: calc(78 / 1920 * 100vw);
  max-height: 68px;
  margin: calc(73 / 1920 * 100vw) 0 calc(48 / 1920 * 100vw) 0;
}
@media (min-width: 1614px) {/* 1614px以上 */
  margin: 60px 0 40px 0;
}
@media (max-width: 768px) {/* 移动端 */
  height:calc(118 / 750 * 100vw);
  margin: calc(61 / 750 * 100vw) 0 calc(55 / 750 * 100vw) 0;
} 
}
.button-part {
display: flex;
justify-content: start;
align-items: center;
@media (min-width: 768px) {/* pc端 */
  gap: calc(13 / 1920 * 100vw);
  margin-bottom: calc(15 / 1920 * 100vw);
}
@media (min-width: 1614px) {/* 1614px以上 */
  gap: 10px;
  margin-bottom: 12px;
}
@media (max-width: 768px) {/* 移动端 */
  // display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  padding: calc(52 / 750 * 100vw);
  background-color: rgba(247, 248, 250, 1); /* 与页面背景一致，避免透明 */
  justify-content: space-between;
}
&.button-part--absolute {
  @media (max-width: 768px) {/* 移动端 */
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    // display: none;
  }
}
img {/* 按钮图片 */
  width: auto;
  @media (min-width: 768px) {/* pc端 */
    width: auto;
    height: calc(48 / 1920 * 100vw);
    max-height: 38px;
    
  }
  @media (max-width: 768px) {/* 移动端 */
    height: calc(76 / 750 * 100vw);
  }
}
.button-article {
  cursor: pointer;
}
}
.moment-popup {
position: fixed;
top: 0;
left: 0;
right: 0;
bottom: 0;
background-color: rgba(247, 248, 250, 1);
z-index: 200;
padding-top: 60px;
overflow-y: auto;
-webkit-overflow-scrolling: touch;
.back-button {
  width: auto;
  height: calc(60 / 750 * 100vw);
  margin: calc(40 / 750 * 100vw) 0 calc(40 / 750 * 100vw) calc(45 / 750 * 100vw);
}
}
.moment-part {
background-color: #fff;
@media (min-width: 768px) {/* pc端 */
  width: 100%;
  position: relative;
}
@media (max-width: 768px) {/* 移动端 */
  width: calc(674 / 750 * 100vw);
  margin: 0 calc(38 / 750 * 100vw);
  padding: calc(40 / 750 * 100vw) calc(38 / 750 * 100vw) calc(20 / 750 * 100vw) calc(38 / 750 * 100vw);

}
}
::v-deep .el-textarea {
  @media (min-width: 768px) {/* pc端 */
      position: initial;
  }
  @media (max-width: 768px) {/* 移动端 */
  }
}
.moment-input {
@media (min-width: 768px) {/* pc端 */
  width: 100%;
  
  
  ::v-deep .el-textarea__inner {
    width: 100%;
    height: calc(150 / 1920 * 100vw);
    max-height: 100px;
    border: none;
    resize: none;
    padding:15px
  }
}
@media (max-width: 768px) {/* 移动端 */
  ::v-deep .el-textarea__inner {
    width: 100%;
    height: calc(300 / 750 * 100vw);
    border: none;
    resize: none;
    padding: 0;
  }
  // ::v-deep .el-input__count {
  //   bottom: calc(-65 / 750 * 100vw);
  // }
}
}
.moment-upload {
.image-upload-wrapper {
  position: relative;
  @media (min-width: 768px) {/* pc端 */
    margin: 0 20px;
  }
  @media (max-width: 768px) {/* 移动端 */
  }
}
.image-upload-hidden {
  // Keep it mounted so we can trigger file picker, but don't display it
  height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
.moment-upload-row {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 10px 0;
  @media (max-width: 768px) {/* 移动端 */
    flex-direction: column;
    align-items: flex-start;
    justify-content: start;

  }
  .upload-image-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
  }
  .upload-image-btn.is-loading {
    pointer-events: none;
  }
  .upload-image-mask {
    position: absolute;
    inset: -6px -0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.65);
    border-radius: 8px;
  }
  .upload-image-spinner {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(0, 0, 0, 0.18);
    border-top-color: rgba(0, 0, 0, 0.55);
    border-radius: 50%;
    animation: footerSpin 0.8s linear infinite;
  }
  .moment-upload-image {
    width: auto;
    cursor: pointer;
    @media (min-width: 768px) {/* pc端 */
      margin-left: 20px;
      height: calc(37 / 1920 * 100vw);
      max-height: 30px;
    }
    @media (max-width: 768px) {/* 移动端 */
      height: calc(58 / 750 * 100vw);
    }
  }
  .moment-upload-tip {
    width: auto;
    color: rgba(123, 124, 124, 1);
    line-height: 1.7;
    font-family: FZLanTingHeiS-R-GB;
    @media (min-width: 768px) {/* pc端 */
      margin-left: 20px;
      // height: calc(17 / 1920 * 100vw);
      // max-height: 13px;
      font-size: calc(15 / 1920 * 100vw);
    }
    @media (min-width: 1614px) {/* 1614px以上 */
      font-size: 12px;
    }
    @media (max-width: 768px) {/* 移动端 */
      font-size: calc(18 / 750 * 100vw);
      margin-top: calc(10 / 750 * 100vw);
      
      
      text-align: left;
    }
  }
}
}
.submit-button-part {
  
  @media (min-width: 768px) {/* pc端 */
      width: 100%;
      margin-top: calc(16 / 1920 * 100vw);
      display: flex;
      justify-content: flex-end;
  }
  @media (min-width: 1614px) {/* 1614px以上 */
    margin-top: 15px;
  }
  @media (max-width: 768px) {/* 移动端 */
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    height: calc(188 / 750 * 100vw);
    background-color: rgba(247, 248, 250, 1); /* 与页面背景一致，避免透明 */
    justify-content: space-between;
    box-shadow: 4px 4px 14px 0px rgba(0, 0, 0, 0.19);

  }
  img {
      @media (min-width: 768px) {/* pc端 */
          width: auto;
          height: calc(45 / 1920 * 100vw);
          max-height: 36px;
          cursor: pointer;
      }
      @media (max-width: 768px) {/* 移动端 */
        
      }
  }
}
.submit-button {
@media (max-width: 768px) {/* 移动端 */
  position: fixed;
  bottom: 0;
  height: calc(100 / 750 * 100vw);
  margin: calc(47 / 750 * 100vw) calc(82 / 750 * 100vw);
  z-index: 201;
}
}
.list-title {
  img {
      @media (min-width: 768px) {/* pc端 */
          width: auto;
          height: calc(40 / 1920 * 100vw);
          margin: calc(30 / 1920 * 100vw) 0;
      }
      @media (min-width: 1614px) {/* 1614px以上 */
          height: 32px;
          margin: 20px 0;
      }
      @media (max-width: 768px) {/* 移动端 */
        height: calc(57 / 750 * 100vw);
        margin-bottom: calc(40 / 750 * 100vw);
      }
  }
}
.recommend-list-part {
  @media (min-width: 768px) {/* pc端 */
      width: 100%;
      
  }
  @media (max-width: 768px) {/* 移动端 */
  }
  .recommend-card {
      @media (min-width: 768px) {/* pc端 */
          background-color: #fff;
          width: 100%;
          padding: 2%;
          margin-bottom: 2%;
      }
      @media (max-width: 768px) {/* 移动端 */
        margin: calc(30 / 750 * 100vw) 0;
      }
  }
  .card-info {
      display: flex;
      align-items: center;
      justify-content: start;
      font-family: "FZLanTingHeiS-R-GB";
      .info-avatar {
          border-radius: 50%;
          @media (min-width: 768px) {/* pc端 */
              width: calc(54 / 1920 * 100vw);
              height: calc(54 / 1920 * 100vw);
              max-width: 45px;
              max-height: 45px;
              
          }
          @media (max-width: 768px) {/* 移动端 */
            width: calc(74 / 750 * 100vw);
            height: calc(74 / 750 * 100vw);
          }
      }
      .info-text {
          display: flex;
          flex-direction: column;
          justify-content: center;
          // align-items: space-between;
          margin-left: 10px;
          
          @media (min-width: 768px) {/* pc端 */
              margin-left: 10px;
              height: calc(54 / 1920 * 100vw);
              max-height: 45px;
          }
          @media (max-width: 768px) {/* 移动端 */
          }
      }
      .info-name {
          color: rgba(123, 124, 124, 1);
          @media (min-width: 768px) {/* pc端 */
              font-size: calc(21 / 1920 * 100vw);
          }
          @media (min-width: 1614px) {/* 1614px以上 */
              font-size: 16px;
          }
          @media (max-width: 768px) {/* 移动端 */
            font-size: calc(29 / 750 * 100vw);
          }
      }
      .info-time {
          color: rgba(170, 170, 170, 1);
          @media (min-width: 768px) {/* pc端 */
              font-size: calc(14 / 1920 * 100vw);
          }
          @media (min-width: 1614px) {/* 1614px以上 */
              font-size: 12px;
          }
          @media (max-width: 768px) {/* 移动端 */
            font-size: calc(18 / 750 * 100vw);
          }
      }
  }
  .card-content {
      font-family: "FZLanTingHeiS-R-GB";
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      cursor: pointer;
      @media (min-width: 768px) {/* pc端 */
          font-size: calc(20 / 1920 * 100vw);
          line-height: calc(31 / 1920 * 100vw);
          margin: calc(20 / 1920 * 100vw) 0;
          line-clamp: 2;
          -webkit-line-clamp: 2;
      }
      @media (min-width: 1614px) {/* 1614px以上 */
          font-size: 15px;
          line-height: 24px;
          margin: 15px 0;
      }
      @media (max-width: 768px) {/* 移动端 */

        font-size: calc(31 / 750 * 100vw);
        line-height: calc(54 / 750 * 100vw);
        margin: calc(20 / 750 * 100vw) 0;
        line-clamp: 5;
        -webkit-line-clamp: 5;
      }
  }
  .card-image {
    cursor: pointer;
      @media (min-width: 768px) {/* pc端 */
          width: 100%;
          aspect-ratio: 1038/570;
          max-height: 100%;
          object-fit: cover;
          object-position: center;
          border-radius: 8px;
          background-color: #f5f5f5; /* 占位背景色 */
      }
      @media (max-width: 768px) {/* 移动端 */
        width: 100%;
        height: calc(365 / 750 * 100vw);
        aspect-ratio: 664/365;
        object-fit: cover;
        object-position: center;
        border-radius: calc(10 / 750 * 100vw);
        background-color: #f5f5f5; /* 占位背景色 */
      }
  }
  .card-footer {
      display: flex;
      align-items: center;
      justify-content: end;
      .card-footer-item {
          color: rgba(0, 0, 0, 0.6);
          display: flex;
          cursor: pointer;
          position: relative;
          @media (min-width: 768px) {/* pc端 */
              margin-left: calc(50 / 1920 * 100vw);
              margin-top: calc(20 / 1920 * 100vw);
          }
          @media (min-width: 1614px) {/* 1614px以上 */
              margin-top: 15px;
              margin-left: 40px;
          }
          @media (max-width: 768px) {/* 移动端 */
            margin-left: calc(46 / 750 * 100vw);
            margin-top: calc(20 / 750 * 100vw);
          }
          img {
              width: auto;
              @media (min-width: 768px) {/* pc端 */
                  width: auto;
                  height: calc(34 / 1920 * 100vw);
                  max-height: 27px;
              }
              @media (max-width: 768px) {/* 移动端 */
                height: calc(54 / 750 * 100vw);
              }
          }
          div {
              font-family: "FZLanTingHeiS-R-GB";
              display: flex;
              align-items: center;
              justify-content: center;
              @media (min-width: 768px) {/* pc端 */
                  margin-top: calc(4 / 1920 * 100vw);
                  font-size: calc(16 / 1920 * 100vw);
              }
              @media (min-width: 1614px) {/* 1614px以上 */
                  margin-top: 3px;
                  font-size: 14px;
              }
              @media (max-width: 768px) {/* 移动端 */
                font-size: calc(25 / 750 * 100vw);
                margin-top: calc(10 / 750 * 100vw);
              }
          }
      }
      .card-footer-item.is-loading {
        pointer-events: none;
      }
      .footer-loading-mask {
        position: absolute;
        inset: -6px -10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.65);
        border-radius: 8px;
      }
      .footer-spinner {
        width: 18px;
        height: 18px;
        border: 2px solid rgba(0, 0, 0, 0.18);
        border-top-color: rgba(0, 0, 0, 0.55);
        border-radius: 50%;
        animation: footerSpin 0.8s linear infinite;
      }
  }
  @keyframes footerSpin {
    to { transform: rotate(360deg); }
  }
  .load-part {
      display: flex;
      align-items: center;
      justify-content: center;
      @media (min-width: 768px){
        padding-top: calc(30 / 1920 * 100vw);
      }
      .load-more-sentinel {
          width: 100%;
          height: 1px;
          pointer-events: none;
          flex-shrink: 0;
      }
      .load-ing {
          display: flex;
          align-items: center;
          justify-content: center;
      }
      .circle {
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border: 2px solid rgba(0, 0, 0, 0.15);
          border-top-color: rgba(0, 0, 0, 0.55);
          box-sizing: border-box;
          animation: circle-rotate 0.9s linear infinite;
          margin-right: 6px;
      }
      img {
          @media (min-width: 768px) {/* pc端 */
              width: auto;
              height: calc(18 / 1920 * 100vw);
              max-height: 14px;
          }
          @media (max-width: 768px) {/* 移动端 */
            height: calc(26 / 750 * 100vw);
          }
      }
  }
}

@keyframes circle-rotate {
from { transform: rotate(0deg); }
to { transform: rotate(360deg); }
}



.advertise-part {
@media (min-width: 768px) {/* pc端 */
  // width: calc(538 / 1920 * 100vw);
  width: 32.5%;
  margin-left: 2%;
  // background-color: beige;
  padding-top: calc(259 / 1920 * 100vw);
}
@media (min-width: 1614px) {/* 1614px以上 */
  padding-top: 215px;
}
@media (max-width: 768px) {/* 移动端 */
}
}
</style>